import { BlurFade } from '@/components/ui/blur-fade';
import { DotPattern } from '@/components/ui/dot-pattern';
import { Shield, Zap, Radio, Bell } from 'lucide-react';

const highlights = [
  {
    icon: Shield,
    title: 'Multi-Tenant Isolation',
    description: 'Complete data separation — every query scoped to your organization with zero cross-tenant exposure.',
  },
  {
    icon: Zap,
    title: 'No-Code Automation',
    description: '14+ actions triggered by ticket events, conditions, and time-based schedules. No developers required.',
  },
  {
    icon: Radio,
    title: 'Real-Time Collaboration',
    description: 'Live ticket updates, typing indicators, and agent presence powered by SignalR across all devices.',
  },
  {
    icon: Bell,
    title: 'Multi-Channel Notifications',
    description: 'Email, in-app, push, and real-time alerts keep your team and customers informed instantly.',
  },
];

export function StatsSection() {
  return (
    <section id="stats" className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <DotPattern className="opacity-[0.15]" />

      <div className="relative z-10 mx-auto max-w-6xl">
        <BlurFade inView>
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground">
              Built for Scale
            </h2>
            <p className="mt-3 sm:mt-4 text-sm sm:text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
              A feature-rich platform designed to grow with your organization.
            </p>
          </div>
        </BlurFade>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {highlights.map((item, index) => (
            <BlurFade key={item.title} delay={index * 0.1} inView>
              <div className="text-center px-4 py-6">
                <div className="mx-auto mb-4 inline-flex h-14 w-14 items-center justify-center rounded-xl bg-primary/10">
                  <item.icon className="h-7 w-7 text-primary" />
                </div>
                <h3 className="text-base font-semibold text-foreground mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {item.description}
                </p>
              </div>
            </BlurFade>
          ))}
        </div>
      </div>
    </section>
  );
}
